/**
 * Skeleton — Bloc placeholder animé pour les états de chargement.
 *
 * Utilisation :
 *   <Skeleton className="h-4 w-32" />
 *   <PropertyCardSkeleton />
 *   <PropertyDetailSkeleton />
 */
import React from 'react';

export const Skeleton = ({ className = '', ...props }) => (
  <div
    className={`animate-pulse bg-stone-200/80 rounded-md ${className}`}
    aria-hidden="true"
    {...props}
  />
);

export const PropertyCardSkeleton = () => (
  <div className="bg-white rounded-2xl overflow-hidden border border-stone-200">
    <Skeleton className="aspect-[4/3] w-full rounded-none" />
    <div className="p-4 space-y-3">
      <Skeleton className="h-7 w-3/4" />
      <Skeleton className="h-4 w-2/3" />
      <div className="flex gap-3 pt-1">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-14" />
      </div>
    </div>
  </div>
);

export const PropertyDetailSkeleton = () => (
  <div className="min-h-dvh bg-paper py-8">
    <div className="max-w-7xl mx-auto px-4">
      <Skeleton className="h-8 w-24 mb-6" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <Skeleton className="h-96 w-full rounded-2xl" />
          <div className="bg-white rounded-2xl p-6 space-y-4">
            <Skeleton className="h-9 w-2/3" />
            <Skeleton className="h-5 w-1/2" />
            <Skeleton className="h-10 w-44" />
            <div className="grid grid-cols-4 gap-3 pt-3">
              {[0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-20" />)}
            </div>
            <Skeleton className="h-32 w-full mt-4" />
          </div>
        </div>
        <div className="space-y-4">
          <Skeleton className="h-64 w-full rounded-2xl" />
          <Skeleton className="h-40 w-full rounded-2xl" />
        </div>
      </div>
    </div>
  </div>
);

export const AgentProfileSkeleton = () => (
  <div className="max-w-5xl mx-auto px-4 py-10 space-y-6">
    <div className="flex items-center gap-5">
      <Skeleton className="h-24 w-24 rounded-full" />
      <div className="flex-1 space-y-3">
        <Skeleton className="h-8 w-1/3" />
        <Skeleton className="h-4 w-1/4" />
      </div>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {[0, 1, 2, 3, 4, 5].map((i) => <PropertyCardSkeleton key={i} />)}
    </div>
  </div>
);

export default Skeleton;
